module.exports = __webpack_public_path__ + "img/Philippines-4-hover.1b4c7c2b.jpg";